import React, { useEffect } from "react";
import "./RegisterNow.scss";
import { useSelector } from "react-redux";
import RegisterForm from '../RegisterForm/RegisterForm';

function RegisterNow() {
    var content = useSelector(state => state.content.pages.register_now);
    
    const form = useSelector((state) => state.content.options.form);

    const submitted =
    useSelector((state) => state.content.options.form_submitted) || false;
    const submitting =
        useSelector((state) => state.content.options.form_submitting) || false;
    const consent_error =
        useSelector((state) => state.content.options.consent_error) || false;

    return (
        <div className={`RegisterNow${submitted ? " submitted" : ""}`}>
            {typeof content !== 'undefined' && !submitted && (
                <h2
                    className="heading"
                    dangerouslySetInnerHTML={{__html: content.form_heading}}
                />
            )}
            <div className="form-container">
                {typeof form !== 'undefined' && (
                    <RegisterForm
                        form={form}
                        submitted={submitted}
                        submitting={submitting}
                        consent_error={consent_error}
                    />
                )}
            </div>
        </div>
    )
}

export default RegisterNow;